import React from 'react';

/**
 * Loading fallback component for Suspense boundaries.
 *
 * Uses a layout-neutral skeleton that works for any page type:
 * a heading bar, a short paragraph block, and several content rows.
 * This avoids the problem of a dashboard-specific skeleton appearing
 * on pages with completely different layouts (calendar, chat, etc.).
 */
const LoadingFallback = () => (
  <div className="p-4 sm:p-6 max-w-4xl mx-auto animate-pulse">
    {/* Page heading */}
    <div className="h-7 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-4" />
    {/* Sub-heading / breadcrumb */}
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/5 mb-6" />

    {/* Generic content rows — works for lists, cards, or text blocks */}
    <div className="space-y-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-lg bg-white dark:bg-gray-800 p-4 shadow">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-3" />
          <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2" />
          <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-5/6" />
        </div>
      ))}
    </div>
  </div>
);

export default LoadingFallback;
